import { useToast } from 'vue-toastification'
import { POSITION } from 'vue-toastification/src/ts/constants'

/**
 * Notification composable
 * Centralized toast notification handling
 */
export function useNotifications() {
  const toast = useToast()

  const showSuccess = (message: string): void => {
    toast.success(message, {
      position: POSITION.TOP_CENTER,
      timeout: 3000,
    })
  }

  const showError = (message: string): void => {
    toast.error(message, {
      position: POSITION.TOP_CENTER,
      timeout: 4000,
    })
  }

  const showWarning = (message: string): void => {
    toast.warning(message, {
      position: POSITION.TOP_CENTER,
      timeout: 3000,
    })
  }

  const showInfo = (message: string): void => {
    toast.info(message, {
      position: POSITION.TOP_CENTER,
      timeout: 3000,
    })
  }

  return {
    showSuccess,
    showError,
    showWarning,
    showInfo,
  }
}
